module.exports = __webpack_public_path__ + "img/members-right-ck2.7f55ac1a.png";